/**
 * The liveness error states
 */

export const LivenessErrorState = {
  CONNECTION_TIMEOUT: 'CONNECTION_TIMEOUT',
  TIMEOUT: 'TIMEOUT',
  RUNTIME_ERROR: 'RUNTIME_ERROR',
  FRESHNESS_TIMEOUT: 'FRESHNESS_TIMEOUT',
  SERVER_ERROR: 'SERVER_ERROR',
  CAMERA_FRAMERATE_ERROR: 'CAMERA_FRAMERATE_ERROR',
  CAMERA_ACCESS_ERROR: 'CAMERA_ACCESS_ERROR',
  FACE_DISTANCE_ERROR: 'FACE_DISTANCE_ERROR',
  MOBILE_LANDSCAPE_ERROR: 'MOBILE_LANDSCAPE_ERROR',
  MULTIPLE_FACES_ERROR: 'MULTIPLE_FACES_ERROR',
} as const;

export type ErrorState = keyof typeof LivenessErrorState;
